import passwordStrengthZxcvbn from './zxcvbn-php';
import passwordStrengthAlert from './password-strength-alert'
import {debounce} from "underscore";
import {debounceTimeout} from './config';
import escape from 'lodash.escape';

const passwordStrength = (button) => {
    $('body').on('input focusout.bs.validator', '#password', debounce((event) => {
        const $el = $(event.target);
        // if (!event.target || !event.target.offsetHeight < 1) {
        //     return;
        // }

        const password = $el.val();

        const parentEl = $el.closest('.form-group')[0];

        const forename = document.querySelector('#firstName') ? document.querySelector('#firstName').value : undefined;
        const surname = document.querySelector('#lastName') ? document.querySelector('#lastName').value : undefined;

        if (!button) {
            button = $('button[type="submit"][data-next_tab]:visible');
        }

        (async () => {
            const score = await passwordStrengthZxcvbn(
                password, {
                    'forename': forename !== undefined ? forename : null,
                    'surname': surname !== undefined ? surname : null
                })
                .then(response => response.score)
                .catch(error => 0);

            let message = $el.data('bs.validator.error');
            let alertType = 'success';
            switch (score) {
                case 0:
                    let matches = password.match(/[^\x00-\x7F]/g);

                    if (matches) {
                        message = $el.data('bs.validator.error.prohibitedsymbols') + escape(matches.join(''))
                        alertType = 'invalid';

                        break;
                    }
                case 1:
                    alertType = 'danger';
                    break;
                case 2:
                    alertType = 'warning';
                    break;
            }

            message = escape(message);

            if (score >= 2) {
                $el.data('is-password-strong', true);
                $el.data('bs.validator.errors', []);

                button.removeAttr('disabled');
            } else {
                $el.data('is-password-strong', false);
                $el.data('bs.validator.errors', [message]);

                button.attr('disabled', 'disabled');
            }

            passwordStrengthAlert(parentEl, $el, alertType, message);
        })();
    }, debounceTimeout * 2));
}

export default passwordStrength;
